import { Validator } from '@vista-digital/validator';
export const defaultCacheDurationsConfig = {
    showtimes: 10,
    tickets: 30,
    items: 30,
    itemAvailabilities: 0,
    films: 30,
    sites: 30,
    cxm: 0,
    member: 30,
    loyaltyMasterData: 30,
    journeys: 30,
    seatAvailabilities: 0,
    seatAvailabilityPreviews: 1,
    seatingMasterData: 30,
    subscriptions: 30,
    events: 30,
    orders: 30,
    paymentMethods: 30
};
const cacheDurationConfigValidator = Validator.number({ min: 0 });
export const cacheDurationsConfigValidator = Validator.object({
    showtimes: cacheDurationConfigValidator,
    tickets: cacheDurationConfigValidator,
    items: cacheDurationConfigValidator,
    itemAvailabilities: cacheDurationConfigValidator,
    films: cacheDurationConfigValidator,
    sites: cacheDurationConfigValidator,
    cxm: cacheDurationConfigValidator,
    member: cacheDurationConfigValidator,
    loyaltyMasterData: cacheDurationConfigValidator,
    journeys: cacheDurationConfigValidator,
    seatAvailabilities: cacheDurationConfigValidator,
    seatAvailabilityPreviews: cacheDurationConfigValidator,
    seatingMasterData: cacheDurationConfigValidator,
    subscriptions: cacheDurationConfigValidator,
    events: cacheDurationConfigValidator,
    orders: cacheDurationConfigValidator,
    paymentMethods: cacheDurationConfigValidator
});
//# sourceMappingURL=cache-durations.js.map